<template>
<div class="wg-map">
    <div class="themesflat-container">
      <div class="row">
        <div class="col-12">
          <div class="top">
            <div id="map"></div>
          </div>
        </div>
      </div>
    </div>
    <ContactUsComponent />
  </div>
</template>

<script>
import axios from "axios";
import ContactUsComponent from "./ContactUsComponent.vue";

/* global google */
export default {
  name: "MapComponent",
  components: {
    ContactUsComponent
  },
  data() {
    return {
      location: null,
      map: null,
      marker: null,
    };
  },
  mounted() {
    axios
      .get(`${process.env.VUE_APP_BASE_URL}/api/map-location`)
      .then((response) => {
        this.location = response.data;

        // Initialize the map once we have data
        this.initMap();
      })
      .catch((error) => {
        console.error("There was an error fetching the data:", error);
      });
  },
  methods: {
    initMap() {
      if (
        !this.location ||
        !this.location.latitude ||
        !this.location.longitude
      ) {
        console.error("Location data is missing!");
        return;
      }

      const coords = {
        lat: parseFloat(this.location.latitude),
        lng: parseFloat(this.location.longitude),
      };

      this.map = new google.maps.Map(document.getElementById("map"), {
        center: coords,
        zoom: 15,
      });

      this.marker = new google.maps.Marker({
        position: coords,
        map: this.map,
        title: "Noor's Coffee",
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
